export default function Footer() {
  return (
    <footer className="footer">
      <span>
        Développé par{" "}
        <a href="https://synchrodev.fr" target="_blank" rel="noopener noreferrer">
          SynchroDev
        </a>
      </span>
    </footer>
  );
}